import React from 'react'

import LandingDarkLayout from '@/components/layouts/LandingDarkLayout/LandingDarkLayout'
import MinimalLayout from '@/components/layouts/MinimalLayout'
import InvalidOrExpiredCard, {
  InvalidOrExpiredCardProps,
} from '@/components/misc/InvalidOrExpiredCard'
import { Container } from '@/components/ui/container'

const InvalidOrExpiredPage: React.FC<InvalidOrExpiredCardProps> = (props) => (
  <LandingDarkLayout>
    <MinimalLayout>
      <Container>
        <InvalidOrExpiredCard {...props} />
      </Container>
    </MinimalLayout>
  </LandingDarkLayout>
)

export default InvalidOrExpiredPage
